import { httpClient } from 'utils/httpClient';
import {
  CompetenciaPayload, CompetenciaResponse,
  NotaCompetenciaMasivoPayload, NotaCompetenciaResponse,
} from 'types/competencia.types';

export const competenciaService = {
  async listByCurso(cursoId: number): Promise<CompetenciaResponse[]> {
    try {
      return await httpClient.get<CompetenciaResponse[]>(`/competencias/curso/${cursoId}`);
    } catch { return []; }
  },
  async crear(payload: CompetenciaPayload): Promise<CompetenciaResponse> {
    return httpClient.post<CompetenciaResponse>('/competencias', payload);
  },
  async actualizar(id: number, payload: CompetenciaPayload): Promise<CompetenciaResponse> {
    return httpClient.put<CompetenciaResponse>(`/competencias/${id}`, payload);
  },
  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/competencias/${id}`);
  },
};

export const notaCompetenciaService = {
  async registrarMasivo(payload: NotaCompetenciaMasivoPayload, registradorId: number): Promise<NotaCompetenciaResponse[]> {
    return httpClient.post<NotaCompetenciaResponse[]>(`/competencias/notas/masivo?registradorId=${registradorId}`, payload);
  },
  async getByMatricula(matriculaId: number, periodoId: number): Promise<NotaCompetenciaResponse[]> {
    try {
      return await httpClient.get<NotaCompetenciaResponse[]>(`/competencias/notas/matricula/${matriculaId}?periodoId=${periodoId}`);
    } catch { return []; }
  },
  async getBySeccion(params: { gradoId: number; seccionId: number; cursoId: number; periodoId: number }): Promise<NotaCompetenciaResponse[]> {
    const q = new URLSearchParams({
      gradoId: String(params.gradoId),
      seccionId: String(params.seccionId),
      cursoId: String(params.cursoId),
      periodoId: String(params.periodoId),
    });
    try {
      return await httpClient.get<NotaCompetenciaResponse[]>(`/competencias/notas/seccion?${q}`);
    } catch { return []; }
  },
};
